import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import {Container, Header, Loader, List, Grid, Message} from 'semantic-ui-react';

import OkdConsoleLink from 'components/Common/OkdConsoleLink/OkdConsoleLink';
import QrCodeModal from 'components/QrCode/QrCodeModal';
import {useHttpClient} from 'hooks';

import styles from './Routes.module.scss';

function renderRoutes(isFetchingRoutes, data, setQrUrl) {
  if (isFetchingRoutes) {
    return <Loader inline="centered" active />;
  } else if (data?.routes === undefined) {
    return <Message error>There was a problem listing the registered URLs</Message>;
  } else if (data.routes.length > 0) {
    return (
      <List>
        {data.routes.map(route => (
          <List.Item key={route}>
            <List.Icon
              name="qrcode"
              className={styles.QrCodeIcon}
              style={{cursor: 'pointer', marginLeft: '0.5rem'}}
              onClick={() => {
                setQrUrl(route);
              }}
            />
            <List.Content>
              <a className={styles.Link} href={route} target="_blank" rel="noreferrer">
                {route}
              </a>
            </List.Content>
          </List.Item>
        ))}
      </List>
    );
  } else {
    return <p>There are no registered URLs in this project.</p>;
  }
}

const Routes = ({projectType, projectName, onRoutesRefresh}) => {
  const {data, error, loading: isFetchingRoutes} = useHttpClient({
    url: `/api/${projectType}/${projectName}/routes`,
    method: 'GET',
  });

  // QR Code
  const [qrUrl, setQrUrl] = useState(null);

  useEffect(() => {
    if (data && !isFetchingRoutes && !error) {
      onRoutesRefresh(data.routes);
    }
  }, [data, isFetchingRoutes, error, onRoutesRefresh]);

  return (
    <Container className={styles.Routes}>
      {!error && <OkdConsoleLink projectType={projectType} projectName={projectName} />}
      <Grid columns={2} stackable>
        <Grid.Column textAlign="left">
          <Header as="h4" textAlign="left" dividing>
            Registered URLs
          </Header>
          {renderRoutes(isFetchingRoutes, data, setQrUrl)}
        </Grid.Column>
        <Grid.Column></Grid.Column>
      </Grid>

      {qrUrl && <QrCodeModal siteUrl={qrUrl} onClose={() => setQrUrl(null)} />}
    </Container>
  );
};

Routes.propTypes = {
  projectType: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  onRoutesRefresh: PropTypes.func.isRequired,
};

export default Routes;
